import { Box, Paper, Stack } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const ExpertsEmptyCalloutPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderColor: theme.palette.divider,
  borderRadius: theme.shape.borderRadiusLg,
  backgroundColor: alpha(theme.palette.primary.main, 0.04),
}));

export const RetainersEmptyCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.tokens.cardShadow,
}));

export const ActivityColumnPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.tokens.cardShadow,
  height: '100%',
  minHeight: 'calc(100vh - 160px)',
}));

export const ActivitySectionHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const DetailsSectionHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  marginBottom: theme.spacing(2),
}));

export const RightColumnPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.tokens.cardShadow,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  minHeight: 'calc(100vh - 160px)',
}));

export const DetailPageRoot = styled(Box)(() => ({
  width: '100%',
  minWidth: 0,
}));
